<template>
  <div v-if="overview">
    <v-card flat :loading="loading" class="mb-4">
      <div class="d-flex flex-no-wrap">
        <v-avatar class="ma-3" size="90">
          <PortraitImage :value="overview.student" large />
        </v-avatar>
        <div>
          <v-card-title class="text-h5"
            ><PersonName :value="overview.student"
          /></v-card-title>

          <v-card-subtitle
            >{{ overview.student.schoolClass.code }}<br />
            Alter: {{ overview.student.age }} Jahre</v-card-subtitle
          >

          <v-chip-group column>
            <v-chip color="error" outlined
              >offen: {{ overview.pendingLessons }}</v-chip
            >

            <v-chip color="success" outlined
              >entschuldigt: {{ overview.excusedLessons }}</v-chip
            >

            <v-chip color="danger" outlined
              >unentschuldigt: {{ overview.unexcusedLessons }}</v-chip
            >

            <v-chip color="info" outlined
              >bezogene Halbtage: {{ overview.halfDays }}</v-chip
            >
          </v-chip-group>
        </div>
      </div>
    </v-card>

    <v-alert
      text
      :type="overview.warningLevel == 1 ? 'warning' : 'error'"
      :prominent="!$vuetify.breakpoint.xs"
      v-if="term && term.current && overview.warningLevel > 0"
    >
      <v-row align="center">
        <v-col class="grow">
          im aktuellen Semester gibt es bereits
          {{ overview.absentLessons }} Absenzen (inklusive pendenter
          Abwesenheiten)
        </v-col>
        <v-col
          class="shrink"
          v-if="$route.name != 'AbsencesOverviewFrequent' && !isProd()"
        >
          <v-btn
            :to="{ name: 'AbsencesOverviewFrequent' }"
            outlined
            :color="overview.warningLevel == 1 ? 'warning' : 'error'"
            >Melden</v-btn
          >
        </v-col>
      </v-row>
    </v-alert>
    <v-toolbar flat dense class="mb-4">
      <v-tabs centered>
        <v-tab exact :to="{ name: 'AbsencesOverviewPending' }">Pendenzen</v-tab>
        <v-tab :to="{ name: 'AbsencesOverviewCalendar' }">Kalender</v-tab>
        <v-tab :to="{ name: 'AbsencesOverviewUnexcused' }"
          >Unentschuldigte</v-tab
        >

        <v-tab
          :to="{ name: 'AbsencesOverviewFrequent' }"
          v-if="!$_hasRole('student') && $_showFrequentAbsences"
          >Meldungen</v-tab
        >

        <v-tab
          :to="{ name: 'AbsencesOverviewExams' }"
          v-if="!$_hasRole('student')"
          >Prüfungen</v-tab
        >
        <v-tab :to="{ name: 'AbsencesOverviewArchive' }">Archiv</v-tab>
      </v-tabs>
    </v-toolbar>

    <router-view
      @updated="fetchData()"
      :id="overview.student.id"
      :student="overview.student"
      :schoolClass="overview.student.schoolClass"
      :term="term"
    />
  </div>
</template>
<script>
import { defineComponent } from "vue";

import PersonName from "common/components/PersonName.vue";
import PortraitImage from "common/components/PortraitImage.vue";

export default defineComponent({
  components: {
    PersonName,
    PortraitImage,
  },
  props: {
    id: { type: Number, default: 0 },
    term: { startDate: 0 },
  },
  data() {
    return {
      dateMenu: false,
      dialog: false,
      focus: "",
      loading: false,
      overview: null,
    };
  },
  computed: {
    canEdit() {
      return this.$_isClassTeacherOf(this.overview.student);
    },
  },
  watch: {
    id(oldValue, newValue) {
      if (oldValue != newValue) {
        this.fetchData();
      }
    },
    term() {
      this.fetchData();
    },
  },

  methods: {
    async fetchData() {
      if (!this.id || !this.term) return;
      this.loading = true;
      this.overview = await this.apiList({
        resource: "absence/overview",
        query: `student=${this.id}&term=${this.term.id}`,
      });

      this.loading = false;
    },
  },
  created() {
    this.fetchData();
  },
});
</script>
